import React from 'react';
import PropTypes from 'prop-types';
import { Spinner } from '@chkp/point.feedback.spinner';
import { Outlined } from '../../Buttons/Button';
import { PointUtils } from '../../../utils/point-ds';
import * as S from './overlay-styled';

/** Point's spinner comes in fixed steps, so a px size rounds up to the next one. The default 72
  has no equivalent and lands on lg (48px). */
const POINT_SIZE_STEPS = [
  [12, 'xxs'],
  [16, 'xs'],
  [24, 'sm'],
  [32, 'md']
];

const toPointSize = size => POINT_SIZE_STEPS.find(([px]) => size <= px)?.[1] || 'lg';

/** `color` and `radiate` style the legacy icon only; Point's spinner keeps its own look. */
export const LoadingSpinner = ({ size = 36, radiate = false, color }) => {
  const isPoint = PointUtils.usePointDS();
  return isPoint ? <Spinner size={toPointSize(size)} /> : <S.Loading size={size} radiate={radiate} color={color} />;
};
LoadingSpinner.propTypes = {
  size: PropTypes.number,
  radiate: PropTypes.bool,
  color: PropTypes.string
};

export const LoadingOverlay = ({ size = 72 }) => (
  <S.TransparentOverlay className="loading-overlay-container">
    <LoadingSpinner size={size} radiate />
  </S.TransparentOverlay>
);
LoadingOverlay.propTypes = {
  size: PropTypes.number
};

export const ImageOverlay = ({ image, children, message, button, onClick }) => {
  return (
    <S.Overlay className="image-overlay-container">
      <S.ImageMessageWrapper>
        {children ?? (
          <>
            {image ? <S.ImageWrapper>{image}</S.ImageWrapper> : <S.ErrorImage />}
            {typeof message === 'string' ? <S.Message>{message}</S.Message> : message}
            {typeof button === 'string' ? <Outlined onClick={onClick}>{button}</Outlined> : button}
          </>
        )}
      </S.ImageMessageWrapper>
    </S.Overlay>
  );
};

ImageOverlay.propTypes = {
  image: PropTypes.node,
  children: PropTypes.node,
  message: PropTypes.node,
  button: PropTypes.node,
  onClick: PropTypes.func
};
